import React from 'react';
import { Link } from "react-router-dom";
import whitelogo from '../assets/img/logo.png';
import blacklogo from '../assets/img/logo-black.png';

const PageNotFound = () => {

    React.useEffect(() => {
        if (document.body.classList.contains('adminbody_bg_notfound')) {
          document.body.classList.remove('body');
    
        }
        document.body.classList.add('adminbody_bg_notfound');
    
      });

    return (
        <div>
            <div className="container">
                <div className="row eform">
                    <div className="col-md-12 eform-login eform-temp">

                        <div className="eform-login-form eform-rightd not-fun-sec">

                            <div className="col-md-12 eform-bottom notfound-sec">
                                <img src={blacklogo} />
                            </div>

                            <div className="col-md-12 eform-top">
                                <div className="four clearfix nt-fn-head">
                                    <h1>404!</h1>
                                    <h5 className="text-gray-soft text-regular">There doesn't seem to be a page here.</h5>
                                    <Link className="btn btn-brand btn-not-login" to="/">Back to login</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default PageNotFound;